<div class="user-settings">
  <section class="user-settings__section">
    <h3 class="user-settings__section-title">{{ 'account.settings.account' | transloco }}</h3>
    <dl class="account-details">
      @for (row of accountRows(); track row) {
        <div class="account-details__row">
          <dt>{{ row.label }}</dt>
          <dd>{{ row.value }}</dd>
        </div>
      }
    </dl>
  </section>

  <section class="user-settings__section">
    <h3 class="user-settings__section-title">{{ 'account.settings.storageSync' | transloco }}</h3>
    <p class="user-settings__intro">{{ 'account.settings.intro' | transloco }}</p>

    <div class="user-settings__cards">
      @for (card of syncCards(); track card) {
        <article class="sync-card">
          <header class="sync-card__header">
            <div class="sync-card__heading">
              <div class="sync-card__title">{{ card.title }}</div>
              <div class="sync-card__description">{{ card.description }}</div>
            </div>
            <span
              class="sync-card__badge"
              [ngClass]="'sync-card__badge--' + syncBadge(card.status).kind"
              >
              {{ syncBadge(card.status).label }}
            </span>
          </header>
          <dl class="sync-card__rows">
            <div class="sync-card__row">
              <dt>{{ 'account.settings.inAccount' | transloco }}</dt>
              <dd>
                {{
                card.status.serverSavedOn
                ? (card.status.serverSavedOn | dateTimeFormat: 'standard')
                : ('account.settings.notSavedYet' | transloco)
                }}
              </dd>
            </div>
            <div class="sync-card__row">
              <dt>{{ 'account.settings.onThisDevice' | transloco }}</dt>
              <dd>
                {{
                card.status.localSavedOn
                ? (card.status.localSavedOn | dateTimeFormat: 'standard')
                : ('account.settings.notSavedYet' | transloco)
                }}
              </dd>
            </div>
          </dl>
        </article>
      }
    </div>

    <p class="user-settings__note">{{ 'account.settings.note' | transloco }}</p>
  </section>
</div>
